import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { ApiService } from '../open-api/api.service';
import { LocalStorageService } from '../utils/local-storage.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    constructor(private readonly authService: AuthService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (
            (this.authService.authenticated && req.url.includes(ApiService.openApiUrl)) ||
            req.url.includes(ApiService.privateApiUrl)
        ) {
            const authReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + LocalStorageService.getToken()),
            });
            return next.handle(authReq);
        }

        return next.handle(req);
    }
}
